import { QueryClient } from "@tanstack/react-query";
import { QueryClientAtomProvider } from "jotai-tanstack-query/react";
import type { ReactNode } from "react";

import { ToastProvider } from "@go-novus/ui";

/**
 * QueryClientAtomProvider 内部已经挂好 jotai Provider，并把 queryClient
 * 注入 queryClientAtom，因此这里是应用里唯一一处装配点。
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: true },
  },
});

export interface AppProvidersProps {
  children?: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientAtomProvider client={queryClient}>
      <ToastProvider>{children}</ToastProvider>
    </QueryClientAtomProvider>
  );
}
